import { genId } from "../../../utils"

const exportTableOfContentsSchema = {
  name: 'exportTableOfContentsSchema',
  _id: genId(),
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: { as: 'Container', className: 'report-root-container schema-print-preview' },
      children: [
        {
          name:'exportTableOfContents',
          type:'exportTableOfContents'
        }
      ]
    },

  ]
}

export { exportTableOfContentsSchema }